module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/227-senegal-6be242a841c35863777cdaadba2a1f21.svg";